import {
    Button,
    dispatchCustomEvent,
    Flexer,
    FormHelperText,
    Heading,
    Modal,
    ModalClose,
    Portal,
    Stack,
    View,
} from '@fold-dev/core'
import { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router'
import { CommonProvider, Error, Loading, UserSelect } from '../components'
import { useProjectUsers, useWorkspaceUsers } from '../hooks/api.hooks'
import { COLORS } from '../constants'
import { useAppStore } from '../store/app'

export const InviteModal = ({ onDismiss, projectId }) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<any>(null)
    const [availableUsers, setAvailableUsers] = useState<any>([])
    const [existingUsers, setExistingUsers] = useState([])
    const [users, setUsers] = useState<any>([])
    const workspaceUsersAPI = useWorkspaceUsers()
    const projectUsersAPI = useProjectUsers()
    const [ready, setReady] = useState(false)
    const { workspaceId } = useParams()
    const workspace = useAppStore((state) => state.workspace)
    //const isAdmin = useMemo(() => workspace.role == 'Owner' || workspace.role == 'Admin', [workspace.role])
    const isAdmin = useMemo(() => workspace.role != 'Guest', [workspace.role])

    const handleAdd = async () => {
        if (users.length >= 8) return setError('Sorry, the limit has been reached.')

        setLoading(true)
        setError(null)

        try {
            await projectUsersAPI.create(workspaceId, projectId, { users })

            dispatchCustomEvent('project:refresh-preview', { id: projectId })
            setAvailableUsers([])
            setUsers([])
            setLoading(false)
            onDismiss()
        } catch (e) {
            setLoading(false)
            setError(typeof e == 'string' ? e : 'An error occured')
        }
    }

    const handleUserAdd = (user) => {
        setUsers([...users, user])
    }

    const handleUserDelete = (user) => {
        setUsers(users.filter((u) => u.id != user.id))
    }

    const handleUserFilter = async (query = '') => {
        if (!ready) return

        setError(null)

        try {
            const users = await workspaceUsersAPI.getSearch(workspaceId, query)

            setAvailableUsers(users.filter((user) => !existingUsers.includes(user.id)))
        } catch (e) {
            setError(typeof e == 'string' ? e : 'An error occured')
        }
    }

    const fetchData = async () => {
        //setLoading(true)
        setError(null)

        try {
            const users = await projectUsersAPI.getAll(workspaceId, projectId)

            setExistingUsers(users.map((user) => user.id))
            setReady(true)
            //setLoading(false)
        } catch (e) {
            //setLoading(false)
            setError(typeof e == 'string' ? e : 'An error occured')
        }
    }

    useEffect(() => {
        if (projectId) fetchData()
    }, [projectId])

    return (
        <Modal
            width={700}
            height="fit-content"
            isVisible={true}
            onDismiss={onDismiss}
            portal={Portal}
            style={{ top: 300 }}
            header={
                <>
                    <Heading as="h4">Add People</Heading>
                    <Flexer />
                    <ModalClose onClick={onDismiss} />
                </>
            }
            footer={
                <>
                    <Button onClick={onDismiss}>Cancel</Button>
                    <Flexer />
                    <Button
                        disabled={!isAdmin}
                        variant="accent"
                        onClick={handleAdd}>
                        Add People
                    </Button>
                </>
            }>
            <View>
                <Error error={error} />
                <Loading loading={loading} />

                <Stack
                    direction="vertical"
                    spacing={15}>
                    <CommonProvider
                        onUserFilter={handleUserFilter}
                        onLabelFilter={(label) => null}
                        availableLabels={[]}
                        availableUsers={availableUsers}
                        colors={COLORS}>
                        <UserSelect
                            hideMe
                            users={users}
                            onAdd={handleUserAdd}
                            onDelete={handleUserDelete}
                            width="100%"
                            variant="default"
                            onOpen={handleUserFilter}
                        />
                    </CommonProvider>
                    <FormHelperText>You are able to add up to 8 users</FormHelperText>
                </Stack>
            </View>
        </Modal>
    )
}
